import MobileDetect from 'mobile-detect';

export const getApolloHeader = (req?: any) => {
  const userAgent = req?.headers['user-agent'];
  const isMobile = userAgent ? !!new MobileDetect(req?.headers['user-agent'] ?? '').mobile() : true;
  const device = isMobile ? 'mobile' : 'pc';

  const cookie = req?.headers['cookie'];
  const nClientIp = req?.headers['n-client-ip'] as string | undefined;

  return {
    cookie,
    deviceType: device,
    nClientIp,
  };
};
